<script setup>
import { computed } from 'vue'
import { useAuthStore } from '@/modules/auth/stores/auth.store'

const props = defineProps({
  size: {
    type: Number,
    default: 40,
  },
  userData: {
    type: Object,
    default: null,
  },
})

const authStore = useAuthStore()

const user = computed(() => props.userData || authStore.userData)

const avatarStyles = computed(() => ({
  width: `${props.size}px`,
  height: `${props.size}px`,
  fontSize: `${Math.floor(props.size * 0.4)}px`,
}))

const initials = computed(() => {
  if (!user.value)
    return ''

  const first = user.value?.firstName?.charAt(0) ?? ''
  const last = user.value?.lastName?.charAt(0) ?? ''

  return `${first}${last}`.toUpperCase()
})

const fullName = computed(() => {
  if (!user.value)
    return ''

  return `${user.value?.firstName || ''} ${user.value?.lastName || ''}`.trim()
})

function handleImageError(event) {
  event.target.style.display = 'none'
}
</script>

<template>
  <div
    class="dss-avatar flex items-center justify-center border-2 text-white bg-dss-surface-menu border-dss-surface-menu rounded-full overflow-hidden"
    :style="avatarStyles"
    :title="fullName"
  >
    <img
      v-if="user?.photo"
      :src="user.photo"
      :alt="fullName"
      class="w-full h-full object-cover"
      @error="handleImageError"
    >
    <span
      v-else
      class="font-bold uppercase text-center"
      :style="{ lineHeight: `${props.size}px` }"
    >
      {{ initials }}
    </span>
  </div>
</template>

<style scoped>
.dss-avatar {
  flex-shrink: 0;
}
</style>
